/**
 * Combine all reducers in this file and export the combined reducers.
 */
import { fromJS } from "immutable";
import { combineReducers } from "redux-immutable";
import { mostVisitedArticlesReducer, mostVisitedProductsReducer } from "./containers/MostVisitedArticles/reducer";
import languageProviderReducer from "./containers/LanguageProvider/reducer";
import { getSite, getLang } from "./utils/url_parser";

/**
 * We are going to define to global state of the app. As MyAD should be user only by signed in users, we need to store
 * a reference to the actual user. This will be in the app property of the state. Other properties in the state are
 * going to be stored using the name of each reducer.
 */
const initialState = fromJS({
  site: getSite(),
  lang: getLang(),
  currentUser: {
    token: AD.getAccessToken()
  }
});

/**
 * Reducer for the global state of the app. As now, we don't have any action to act so this reducer may look as
 * unnecessary, but probably in the future we will need some action to act on the current signed in user.
 * @param state initial state of the app.
 * @param action dispatched action.
 * @returns {any} global state of the app.
 */
function appReducer (state = initialState, action) {
  switch (action.type) {
    default:
      return state;
  }
}

const recommendationsReducer = combineReducers({
  mostVisitedArticles: mostVisitedArticlesReducer,
  mostVisitedProducts: mostVisitedProductsReducer
});

/**
 * Creates the main reducer with the dynamically injected ones
 */
export default function createReducer (injectedReducers) {
  return combineReducers({
    app: appReducer,
    language: languageProviderReducer,
    recommendations: recommendationsReducer,
    ...injectedReducers
  });
}
